// extracted by mini-css-extract-plugin
module.exports = {"shareBox":"shareHistory_shareBox__1SQ25","title":"shareHistory_title__XMaTx","name":"shareHistory_name__2A8Ua"};